<ids-snackbar
  [variant]="alert.variant"
  [(show)]="alert.show"
  [ngStyle]="{ display: !alert.show ? 'none' : '' }"
  [attr.data-testid]="'alert-' + alert.testId"
>
  <ids-icon>{{
    alert.variant === "success" ? "confirmacao" : "error_circle_base"
  }}</ids-icon>
  {{ alert.message }}
</ids-snackbar>
